<template>
  <div class="WidgetDetailsView">
    <PageHeader title="Konfigurator widgetu" />
    <ShPageLayout>
      <WidgetStyleAndConfiguration :widget="widget"
                                   :is-loading="isLoading"
      />
      <WidgetConfigurationSave :widget="widget"
                               :is-loading="isLoading"
      />
    </ShPageLayout>
  </div>
</template>

<script>
import ShPageLayout from '@/components/Helpers/ShPageLayout';
import PageHeader from '@/components/Common/PageHeader';
import WidgetStyleAndConfiguration from '@/components/Widgets/WidgetStyleAndConfiguration';
import WidgetConfigurationSave from '@/components/Widgets/WidgetConfigurationSave';

export default {
  name: 'WidgetDetailsView',
  components: {
    ShPageLayout,
    PageHeader,
    WidgetStyleAndConfiguration,
    WidgetConfigurationSave,
  },


  computed: {
    isLoading() {
      return this.$store.getters['app/pendingStoreActions'].includes([
        'widgets/getOne',
        'widgets/saveConfiguration',
      ]);
    },
    widget() {
      return this.$store.getters['widgets/one'];
    },
  },

  created() {
    this.getWidget();
  },

  methods: {
    getWidget() {
      try {
        const { id } = this.$route.params;
        // TODO: obsługa jeżeli nie ma 'id'
        this.$store.dispatch('widgets/getOne', id);
      } catch (e) {
        console.log(e);
        // TODO: obsługa jeżeli podczas pobierania coś się nie uda
      }
    },
  },
};
</script>

<style lang="sass" scoped>
.WidgetDetailsView
  padding-bottom: 50px
</style>
